import React                           from 'react';
import {
  IFormContext,
  Form,
}                                      from 'rewire-ui';
import Divider                         from '@material-ui/core/Divider';
import { capitalize }                  from '../utility/StringUtils';
import mainPageModel                   from '../main-navigation/MainPageModel';
import EditDialogModel                 from '../schedule/EditDialogModel';
import authService from '../services/AuthService';

export class BillingDialogModel extends EditDialogModel {
  constructor() {
    super(
      '',
      async (_ids: string[]) => [mainPageModel.location],
      async () => undefined,
      async () => undefined,
      async () => undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    );

    this.action('manage', this.loadStripePortal, { variant: 'contained', tooltip: () => this.actions.manage?.disabled() ? 'Only Plan Administrators can manage billing plans' : '', disabled: () => !mainPageModel.canEditBilling });
  }

  protected fields(form: IFormContext) {
    return ({
      tier:                form.static().label('Tier'),
      planAdministrator:   form.static().label('Plan Administrator'),
      subscriptionExpires: form.static().label('Subscription Expiry'),
      subscriptionCount:   form.static().label('Subscription Users'),
      activeUsers:         form.static().label('Active Users'),
      divider2:            form.custom(() => (<Divider />)),
      employeeCount:       form.static().label('Subscription Employees'),
      activeEmployees:     form.static().label('Active Employees'),
    });
  }

  protected _createForm(): Form {
    return Form.create((form: IFormContext) => ({
      ...this.fields(form)
    }));
  }

  public mapToForm(obj: ObjectType): ObjectType {
    const planFormData = {
      tier: capitalize(obj.tier),
      planAdministrator: obj.planAdministrator?.name,
      subscriptionExpires: obj.subscriptionExpires?.toDateString(),
      subscriptionCount: obj.subscriptionCount,
      activeUsers: obj.activeUsers,
      employeeCount: obj.employeeCount,
      activeEmployees: obj.activeEmployees,
    };
    return planFormData;
  }

  protected getTitle(): string {
    return '';
  }

  public async loadStripePortal() {
    const returnUrl = new URL('/home/settings', window.location.href);
    const url       = new URL('/stripe/v1/customer-portal', window.location.href);
    const request: RequestInit = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authService.sessionId,
      },
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({returnUrl: returnUrl.href})
    };
    try {
      const x = await (await fetch(url.href, request))?.json();
      if (x.stripeUrl) {
        window.location.href = x.stripeUrl;
      }
    } catch (err) {
      console.error(err);
      return false;
    }

    return false;
  }
}

const billingDialogModel = new BillingDialogModel();
export default billingDialogModel;
